const locales = 'nl-NL';

const dateFormatOptions = {
  dateStyle: 'short',
};

const timeFormatOptions = {
  timeStyle: 'short',
};

export function parseDateTimeRange(startDateTimeString, endDateTimeString) {
  const startDateTime = new Date(startDateTimeString),
        startDateTimeIsValid = !isNaN(startDateTime),
        endDateTime = new Date(endDateTimeString),
        endDateTimeIsValid = !isNaN(endDateTime);

  if (!startDateTimeIsValid) {
    return 'datum // tijd';
  }

  const displayStartDate = startDateTime.toLocaleDateString(locales, dateFormatOptions);
  const displayStartTime = startDateTime.toLocaleTimeString(locales, timeFormatOptions);

  if (
    startDateTimeIsValid
    && !endDateTimeIsValid
  ) {
    return `${displayStartDate} // ${displayStartTime}`;
  }

  const displayEndDate = endDateTime.toLocaleDateString(locales, dateFormatOptions),
        displayEndTime = endDateTime.toLocaleTimeString(locales, timeFormatOptions);

  if (
    startDateTimeIsValid
    && endDateTimeIsValid
    && displayStartDate === displayEndDate
  ) {
    return `${displayStartDate} // ${displayStartTime} - ${displayEndTime}`;
  }

  return `${displayStartDate} ${displayStartTime} // ${displayEndDate} ${displayEndTime}`;
}

export function parseDate(dateTimeString) {
  const date = new Date(dateTimeString);
  if (isNaN(date)) return dateTimeString;

  const dateString = date.toLocaleDateString(locales, dateFormatOptions);
  const timeString = date.toLocaleTimeString(locales, timeFormatOptions);

  return `${dateString} ${timeString}`;
}

export function parseIdFromString(string) {
  return string
    .replace(/[^a-zA-Z0-9 ]/g, '')
    .replace(' ', '-')
    .toLowerCase();
}
